import React, { Component, lazy } from 'react';
import { Switch } from 'react-router-dom';

import { RouteWrapper } from 'components/layout/helper';
import { ROUTES, PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import withSuspense from 'hoc/withSuspense';
import { AuthService } from 'modules/auth';

const Dashboard = lazy(() => import('./Dashboard'));

class DashboardIndex extends Component {
  render() {
    if (!AuthService.hasDashboardEnabled) {
      return null;
    }

    return (
      <Switch>
        <RouteWrapper
          track={PAGE_VIEW_EVENTS.DASHBOARD}
          path={ROUTES.DASHBOARD}
          render={withSuspense(Dashboard)}
        />
      </Switch>
    );
  }
}

export default DashboardIndex;
